/* istanbul ignore file */
import React from 'react'

import { CardColorProps } from '../BaseIcon'
import { Amex } from './amex'
import { Applepay } from './applepay'
import { CashPay } from './cash-pay'
import { GenericBank } from './generic-bank'
import { Mastercard } from './mastercard'
import { Visa } from './visa'

type CardComponent = React.ComponentType<CardColorProps>

export const EagerCards: Record<string, CardComponent> = {
  Amex,
  Applepay,
  CashPay,
  GenericBank,
  Mastercard,
  Visa,
}

export const LazyCards: Record<string, CardComponent> = {
  Cirrus: React.lazy(async () => import('./cirrus').then((m) => ({ default: m.Cirrus }))),
  Dinersclub: React.lazy(async () => import('./dinersclub').then((m) => ({ default: m.Dinersclub }))),
  Discover: React.lazy(async () => import('./discover').then((m) => ({ default: m.Discover }))),
  Jcb: React.lazy(async () => import('./jcb').then((m) => ({ default: m.Jcb }))),
  Maestro: React.lazy(async () => import('./maestro').then((m) => ({ default: m.Maestro }))),
  Unionpay: React.lazy(async () => import('./unionpay').then((m) => ({ default: m.Unionpay }))),
}
